import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimelineScale } from './types';

interface TimelineScaleSelectProps {
    onOpenSchedule: () => void;
    onScaleChange: (scale: TimelineScale) => void;
    value: 'schedule' | TimelineScale;
}

export const TimelineScaleSelect: React.FC<TimelineScaleSelectProps> = ({
    onOpenSchedule, onScaleChange, value,
}) => {
    const { t } = useTranslation();
    return (
        <label className="timeline-view-selector">
            <span className="sr-only">{t('dailyPlanner.timelineView')}</span>
            <select value={value} onChange={(event) => {
                if (event.target.value === 'schedule') onOpenSchedule();
                else onScaleChange(event.target.value as TimelineScale);
            }} aria-label={t('dailyPlanner.timelineView')}>
                <option value="schedule">{t('dailyPlanner.schedule')}</option>
                <option value="day">{t('dailyPlanner.units.day')}</option>
                <option value="month">{t('dailyPlanner.units.month')}</option>
                <option value="year">{t('dailyPlanner.units.year')}</option>
                <option value="years">{t('dailyPlanner.units.years')}</option>
            </select>
        </label>
    );
};
